import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

export class MultiTicketSlickChangeAction extends BaseAction<void, { legIndex: number }> {

    override async run(): Promise<void> {
        try {
            const { legIndex } = this.params!;
            updateRecoilState("currentLegIndexTicketAtom", legIndex)
        } catch (error) {
            console.error("Error in MultiTicketSlickChangeAction:", error);
        }
    }
}

// Create a singleton instance
export const multiTicketSlickChangeAction = new MultiTicketSlickChangeAction(); 